module.exports = __webpack_public_path__ + "img/face_blowing_a_kiss.963d6051.gif";